import { PageType } from '@/components/entities/requests/model/types'

import { RequestsTypeSelectOption } from './RequestsTypeSelect.types'

export const tabs: RequestsTypeSelectOption[] = [
  {
    key: PageType.Passes,
    title: 'Пропуска'
  },
  {
    key: PageType.Requests,
    title: 'Обращения'
  }
]
